import React from "react"
import { Tooltip } from "react-bootstrap"
import HRRStateWebWorker from "./HRRStateWebWorker"
import WebWorker from "./HRRWebWorkerSetup"
import mutate from "./mutate"
import EmployeeMiniTypes from "../types/EmployeeMiniTypes"
import ReportTypes from "../types/ReportTypes"
import dayjs from "dayjs"


const HRRService = {
    webWorker: new WebWorker(HRRStateWebWorker),
    state: {
        firstLoad: false,
        employeeReport: [],
        selectedReport: null as ReportTypes,
        progress: 0,
        reporting: false,
        fetchingEmployees: false,
        finished: false,
        viewReport: false,
        sortOptions: { key: "", direction: "ASC" }
    },
    cleanUp: () => {
        HRRService.manageState([
            { key: "firstLoad", value: false },
            { key: "employeeReport", value: [] },
            { key: "selectedReport", value: null },
            { key: "progress", value: 0 },
            { key: "reporting", value: false },
            { key: "fetchingEmployees", value: false },
            { key: "finished", value: false },
            { key: "viewReport", value: false }
        ])
    },
    manageState: (keys: Array<{ key: string, value?: any }>) => {
        //@ts-ignore
        HRRService.webWorker.postMessage({ action: "updateHRRState", payload: mutate(HRRService.state, keys) })
    },
    getEmployeeIdsFromSelection: (employees: EmployeeMiniTypes[]) => {
        let ids: number[] = []
        for (let i = 0; i < employees.length; i++) {
            const employee: EmployeeMiniTypes = employees[i]
            ids.push(employee.UserId)
        }
        return ids
    },
    filterEmployeesFromReportFilterKeys: (employees: EmployeeMiniTypes[]) => {
        //@ts-ignore
        const keys = HRRService.state.selectedReport.properties?.filterOn
        let filteredEmployees: EmployeeMiniTypes[] = []

        for (let i = 0; i < employees.length; i++) {
            const employee = employees[i]
            let isMatchedAll = true // Assume it matches all conditions by default

            for (let j = 0; j < keys.length; j++) {
                const key = keys[j].key
                const value = keys[j].value
                //@ts-ignore
                if (employee[key] !== value) {
                    isMatchedAll = false // If even one key doesn't match, set this to false
                    break // Exit the inner loop as soon as one key doesn't match
                }
            }

            if (isMatchedAll) {
                filteredEmployees.push(employee) // If all the keys matched, add the employee to the filtered list
            }
        }

        return filteredEmployees
    },
    nameReport: () => {
        //@ts-ignore
        return `${HRRService.state.selectedReport.name}-${dayjs().format("MM-DD-YYYY")}`
    },
    HRRServiceTooltip: (text: string) => (
        <Tooltip id={`eala-service-tooltip`}>
            {text}
        </Tooltip>
    )
}

export default HRRService